export default __webpack_public_path__ + "static/Airgap_blue-caafb40c8df4f41c2738421ecdfb55dc.svg";